<template>
    <div class="homeworkTopic">
        <!--专题方案-->
        <div class="content-1eKWM">
            <div class="nav-list-2Nhkq">

            </div>

        </div>
    </div>

</template>

<script>
    export default {
        name: "homeworkTopic",
        data() {
            return {
                activeName: 'first'
            }
        },
        methods: {}
    }
</script>
<style lang="scss">
    .homeworkTopic {
        .el-tabs__item {
            height: 50px !important;
        }
    }

</style>

<style scoped lang="scss">
    .homeworkTopic {
        .content-1eKWM {
            background-color: white;
            margin: 24px 32px;
            overflow: hidden;
            padding: 0 32px;
        }

        .topic-special-container-102dY {
            .filter-2qeA8 {
                margin: 10px 0;

                .lz-tab-filter {
                    font-size: 14px;
                    display: flex;
                    overflow: hidden;
                    transition: height .3s;

                    .lz-tab-filter-label {
                        color: #7c89a7;
                        line-height: 1;
                        padding: 5px 0;
                        margin-right: 17px;
                    }

                    .lz-tab-filter-content {
                        color: #223459;
                        font-size: 14px;

                        .lz-tab-filter-li {
                            display: inline-block;
                            margin: 0 10px 12px 0;
                            border-radius: 4px;

                            .el-button {
                                display: inline;
                                border: none;
                                cursor: pointer;
                                padding: 5px 10px;
                                outline: none;
                                line-height: 1;

                            }
                        }
                    }
                }
            }
            .list-1l_vv{
                .topic-special-item-3kOj3 {
                    height: 172px;
                    padding: 16px;
                    display: flex;
                    border: 1px solid #ededee;
                    border-radius: 8px;
                    box-shadow: 0 0 6px 0 rgba(90,139,255,0.12);
                    margin-bottom: 24px;
                    .logo-1aiQ5 {
                        height: 140px;
                        width: 220px;
                        margin-right: 16px;
                        position: relative;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                        .gds-2NrtH {
                            position: absolute;
                            top: 3px;
                            right: 3px;
                            .gd-1FW_7 {
                                background: linear-gradient(90deg, #76d04a 2%, #a6e442 99%);
                                border-radius: 2px;
                                padding: 0 10px;
                                height: 24px;
                                margin-bottom: 5px;
                                color: white;
                                line-height: 24px;
                            }
                            .gd-1FW_7:nth-child(1) {
                                background: linear-gradient(90deg, #76d04a 2%, #a6e442 99%);
                            }
                            .gd-1FW_7:nth-child(2) {
                                background: linear-gradient(90deg, #55a4fa 2%, #82ccef 99%);
                            }
                        }
                    }
                    .right-392d_ {
                        position: relative;
                        .tit-332pk {
                            font-size: 16px;
                            color: #314059;
                            line-height: 20px;
                            margin-bottom: 8px;
                            cursor: pointer;
                            display: block;
                        }
                        .desc-1k5Ww {
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 3;
                            overflow: hidden;
                            font-size: 14px;
                            color: #7c89a7;
                            line-height: 18px;
                        }
                        .date-yJ3-9 {
                            font-size: 12px;
                            color: #96a2be;
                            line-height: 15px;
                            margin: 4px 0 8px;
                        }
                        .btn-1COR3 {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 88px;
                            height: 32px;
                            background: #5a8bff;
                            border-radius: 4px;
                            text-align: center;
                            line-height: 32px;
                            font-size: 14px;
                            color: white;
                            cursor: pointer;
                        }
                        .vbtn-1dFPg {
                            position: absolute;
                            bottom: 0;
                            left: 110px;
                            width: 88px;
                            height: 32px;
                            background: #ffffff;
                            border: 1px solid #5b8aff;
                            border-radius: 4px;
                            text-align: center;
                            line-height: 32px;
                            font-size: 14px;
                            color: #5b8aff;
                            cursor: pointer;
                        }
                    }
                }
            }

        }
    }
</style>
